import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Linkedin } from 'lucide-react';

const INDUSTRIES = [
  { label: 'Mining', to: '/mining' },
  { label: 'Cement & Materials', to: '/cement' },
  { label: 'Energy & Power', to: '/energy' },
  { label: 'Oil & Gas', to: '/oil-gas' },
  { label: 'Manufacturing', to: '/manufacturing' },
  { label: 'Machinery & OEM', to: '/machinery' },
  { label: 'Construction', to: '/construction' },
];

const COMPANY = [
  { label: 'Offerings', to: '/offerings' },
  { label: 'Capabilities', to: '/capabilities' },
  { label: 'About', to: '/about' },
  { label: 'Book a meeting', to: '/book-a-meeting' },
];

export const Footer = () => {
  const year = new Date().getFullYear();
  return (
    <footer className="dark-footer" id="contact" data-testid="site-footer">
      <div className="footer-content">
        <div className="footer-section">
          <Link to="/" aria-label="Aplied.ai home">
            <img src="/logos/aplied-logo-white.png" alt="APLIED.AI" className="footer-logo" />
          </Link>
          <p className="footer-description">
            Turning heavy industry&apos;s existing data into profitable AI solutions.
          </p>
          <p className="footer-description" style={{ marginTop: 12, opacity: 0.55, fontSize: 14 }}>
            Part of VXC Group. Copenhagen, Denmark - working globally.
          </p>
        </div>

        <div className="footer-section">
          <h4 className="footer-heading">Industries</h4>
          <div className="footer-links">
            {INDUSTRIES.map((item) => (
              <Link
                key={item.to}
                to={item.to}
                className="footer-link"
                data-testid={`footer-industry-${item.to.replace('/', '')}`}
              >
                {item.label}
              </Link>
            ))}
          </div>
        </div>

        <div className="footer-section">
          <h4 className="footer-heading">Company</h4>
          <div className="footer-links">
            {COMPANY.map((item) => (
              <Link
                key={item.to}
                to={item.to}
                className="footer-link"
                data-testid={`footer-company-${item.to.replace('/', '')}`}
              >
                {item.label}
              </Link>
            ))}
          </div>
        </div>

        <div className="footer-section">
          <h4 className="footer-heading">Connect</h4>
          <div className="footer-social" data-testid="footer-social">
            <a
              href="mailto:mak@aplied.ai"
              className="footer-social-link"
              aria-label="Email us"
              data-testid="footer-email"
            >
              <Mail size={20} />
            </a>
            <a
              href="https://www.linkedin.com/company/aplied-ai/"
              target="_blank"
              rel="noopener noreferrer"
              className="footer-social-link"
              aria-label="Aplied.ai on LinkedIn"
              data-testid="footer-linkedin"
            >
              <Linkedin size={20} />
            </a>
          </div>
          <div className="footer-links" style={{ marginTop: 28 }}>
            <a
              href="mailto:mak@aplied.ai"
              className="footer-link"
              data-testid="footer-email-text"
              style={{ wordBreak: 'break-word' }}
            >
              mak@aplied.ai
            </a>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <p className="footer-copyright">
          © {year} Aplied.ai. All rights reserved.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
